import { render, staticRenderFns } from "./PanelDetail.vue?vue&type=template&id=035c9192&scoped=true&"
import script from "./PanelDetail.vue?vue&type=script&lang=js&"
export * from "./PanelDetail.vue?vue&type=script&lang=js&"
import style0 from "./PanelDetail.vue?vue&type=style&index=0&id=035c9192&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c9192",
  null
  
)

export default component.exports